// 97 elements
export const normsNutrients = [
  // Podstawowe składniki odżywcze
  'energy_value_kj',
  'energy_value_according_regulation_kcal',
  'energy_value_according_regulation_kj',
  'carbohydrates_total',
  'animal_protein',
  'plant_protein',
  'protein_according_regulation',
  'fiber',
  // Składniki mineralne
  'sodium',
  'potassium',
  'calcium',
  'phosphorus',
  'magnesium',
  'iron',
  'zinc',
  'copper',
  'iodine',
  'manganese',
  // Witaminy
  'thiamin',
  'riboflavin',
  'niacin',
  'folate_total',
  'vitamin_B_12',
  'vitamin_B6',
  'vitamin_A_RAE',
  'vitamin_C',
  'vitamin_D',
  'vitamin_E',
  'carotene_beta',
  'retinol',
  // Aminokwasy
  'isoleucine',
  'leucine',
  'lysine',
  'methionine',
  'cystine',
  'phenylalanine',
  'tyrosine',
  'threonine',
  'tryptophan',
  'valine',
  'arginine',
  'histidine',
  'alanine',
  'aspartic_acid',
  'glutamic_acid',
  'glycine',
  'proline',
  'serine',
  // Kwasy tłuszczowe
  'c_4_0',
  'c_6_0',
  'c_8_0',
  'c_10_0',
  'c_12_0',
  'c_14_0',
  'c_15_0',
  'c_16_0',
  'c_17_0',
  'c_18_0',
  'c_20_0',
  'nkt',
  'c_14_1',
  'c_15_1',
  'c_16_1',
  'c_17_1',
  'c_18_1',
  'c_20_1',
  'c_22_1',
  'jnkt',
  'c_18_2',
  'c_18_3',
  'c_18_4',
  'c_20_3',
  'c_20_4',
  'c_20_5',
  'c_22_5',
  'c_22_6',
  'wnkt',
  'n_6',
  'n_3',
  'cholesterol',
  // Inne
  'waste',
  'water',
  'sucrose',
  'lactose',
  'starch',
  'ash',
  'salt',
  'glucose',
  'fructose',
  'protein_energy',
  'fat_energy',
  'carbohydrates_energy',
  'glycemic_index',
  'glycemic_load',
  'simple_sugars_sum',
  'carbohydrate_exchanger',
  'protein_fat_exchangers',
] as const

export const normsAssumptions = [
  {
    name: 'Podstawowe składniki odżywcze',
    nutrients: {
      animal_protein: {
        maxValue: 10000,
        name: 'Białko zwierzęce',
        tooltip: '',
      },
      carbohydrates_total: {
        maxValue: 10000,
        name: 'Węglowodany ogółem',
        tooltip: '',
      },
      energy_value_according_regulation_kcal: {
        maxValue: 10000,
        name: 'Wart. energ. wg Rozp. 1169/2011',
        tooltip: '',
      },
      energy_value_according_regulation_kj: {
        maxValue: 100000,
        name: 'Wart. energ. wg Rozp. 1169/2011 kJ',
        tooltip: '',
      },
      energy_value_kj: {
        maxValue: 100000,
        name: 'Wartość energetyczna kJ',
        tooltip: '',
      },
      fiber: {
        maxValue: 10000,
        name: 'Błonnik',
        tooltip: '',
      },
      plant_protein: {
        maxValue: 10000,
        name: 'Białko roślinne',
        tooltip: '',
      },
      protein_according_regulation: {
        maxValue: 10000,
        name: 'Białko ogółem wg Rozp 1169/2011',
        tooltip: '',
      },
    },
  },
  {
    name: 'Składniki mineralne',
    nutrients: {
      calcium: {
        maxValue: 10000,
        name: 'Wapń',
        tooltip: '',
      },
      copper: {
        maxValue: 10000,
        name: 'Miedź',
        tooltip: '',
      },
      iodine: {
        maxValue: 10000,
        name: 'Jod',
        tooltip:
          'Normy ustalane na podstawie badań lub obserwacji przeciętnego spożycia żywności przez osoby zdrowe i prawidłowo odżywione (AI).',
      },
      iron: {
        maxValue: 10000,
        name: 'Żelazo',
        tooltip: '',
      },
      magnesium: {
        maxValue: 10000,
        name: 'Magnez',
        tooltip: '',
      },
      manganese: {
        maxValue: 10000,
        name: 'Mangan',
        tooltip:
          'Normy ustalane na podstawie badań lub obserwacji przeciętnego spożycia żywności przez osoby zdrowe i prawidłowo odżywione (AI).',
      },
      phosphorus: {
        maxValue: 10000,
        name: 'Fosfor',
        tooltip: '',
      },
      potassium: {
        maxValue: 10000,
        name: 'Potas',
        tooltip:
          'Normy ustalane na podstawie badań lub obserwacji przeciętnego spożycia żywności przez osoby zdrowe i prawidłowo odżywione (AI).',
      },
      sodium: {
        maxValue: 10000,
        name: 'Sód',
        tooltip:
          'Normy ustalane na podstawie badań lub obserwacji przeciętnego spożycia żywności przez osoby zdrowe i prawidłowo odżywione (AI).',
      },
      zinc: {
        maxValue: 10000,
        name: 'Cynk',
        tooltip: '',
      },
    },
  },
  {
    name: 'Witaminy',
    nutrients: {
      carotene_beta: {
        maxValue: 10000,
        name: 'β-karoten',
        tooltip: '',
      },
      folate_total: {
        maxValue: 10000,
        name: 'Foliany',
        tooltip: 'Witamina B9',
      },
      niacin: {
        maxValue: 10000,
        name: 'Niacyna',
        tooltip: 'Witamina PP/B3',
      },
      retinol: {
        maxValue: 10000,
        name: 'Retinol',
        tooltip: '',
      },
      riboflavin: {
        maxValue: 10000,
        name: 'Ryboflawina',
        tooltip: 'Witamina B2',
      },
      thiamin: {
        maxValue: 10000,
        name: 'Tiamina',
        tooltip: 'Witamina B1',
      },
      vitamin_A_RAE: {
        maxValue: 10000,
        name: 'Ekwiwalent Retinolu',
        tooltip: 'Witamina A',
      },
      vitamin_B_12: {
        maxValue: 10000,
        name: 'Kobalamina',
        tooltip: 'Witamina B12',
      },
      vitamin_B6: {
        maxValue: 10000,
        name: 'Pirydoksyna',
        tooltip: 'Witamina B6',
      },
      vitamin_C: {
        maxValue: 10000,
        name: 'Witamina C',
        tooltip: '',
      },
      vitamin_D: {
        maxValue: 10000,
        name: 'Witamina D',
        tooltip:
          'Normy ustalane na podstawie badań lub obserwacji przeciętnego spożycia żywności przez osoby zdrowe i prawidłowo odżywione (AI).',
      },
      vitamin_E: {
        maxValue: 10000,
        name: 'Witamina E',
        tooltip:
          'Normy ustalane na podstawie badań lub obserwacji przeciętnego spożycia żywności przez osoby zdrowe i prawidłowo odżywione (AI).',
      },
    },
  },
  {
    name: 'Aminokwasy',
    nutrients: {
      alanine: {
        maxValue: 10000,
        name: 'Alanina',
        tooltip: '',
      },
      arginine: {
        maxValue: 10000,
        name: 'Arginina',
        tooltip: '',
      },
      aspartic_acid: {
        maxValue: 10000,
        name: 'Kwas asparaginowy',
        tooltip: '',
      },
      cystine: {
        maxValue: 10000,
        name: 'Cysteina',
        tooltip: '',
      },
      glutamic_acid: {
        maxValue: 10000,
        name: 'Kwas glutaminowy',
        tooltip: '',
      },
      glycine: {
        maxValue: 10000,
        name: 'Glicyna',
        tooltip: '',
      },
      histidine: {
        maxValue: 10000,
        name: 'Histydyna',
        tooltip: '',
      },
      isoleucine: {
        maxValue: 10000,
        name: 'Izoleucyna',
        tooltip: '',
      },
      leucine: {
        maxValue: 10000,
        name: 'Leucyna',
        tooltip: '',
      },
      lysine: {
        maxValue: 10000,
        name: 'Lizyna',
        tooltip: '',
      },
      methionine: {
        maxValue: 10000,
        name: 'Metionina',
        tooltip: '',
      },
      phenylalanine: {
        maxValue: 10000,
        name: 'Fenyloalanina',
        tooltip: '',
      },
      proline: {
        maxValue: 10000,
        name: 'Prolina',
        tooltip: '',
      },
      serine: {
        maxValue: 10000,
        name: 'Seryna',
        tooltip: '',
      },
      threonine: {
        maxValue: 10000,
        name: 'Treonina',
        tooltip: '',
      },
      tryptophan: {
        maxValue: 10000,
        name: 'Tryptofan',
        tooltip: '',
      },
      tyrosine: {
        maxValue: 10000,
        name: 'Tyrozyna',
        tooltip: '',
      },
      valine: {
        maxValue: 10000,
        name: 'Walina',
        tooltip: '',
      },
    },
  },
  {
    name: 'Kwasy tłuszczowe',
    nutrients: {
      c_4_0: {
        maxValue: 10000,
        name: 'C4:0',
        tooltip: '',
      },
      c_6_0: {
        maxValue: 10000,
        name: 'C6:0',
        tooltip: '',
      },
      c_8_0: {
        maxValue: 10000,
        name: 'C8:0',
        tooltip: '',
      },
      c_10_0: {
        maxValue: 10000,
        name: 'C10:0',
        tooltip: '',
      },
      c_12_0: {
        maxValue: 10000,
        name: 'C12:0',
        tooltip: '',
      },
      c_14_0: {
        maxValue: 10000,
        name: 'C14:0',
        tooltip: '',
      },
      c_14_1: {
        maxValue: 10000,
        name: 'C14:1',
        tooltip: '',
      },
      c_15_0: {
        maxValue: 10000,
        name: 'C15:0',
        tooltip: '',
      },
      c_15_1: {
        maxValue: 10000,
        name: 'C15:1',
        tooltip: '',
      },
      c_16_0: {
        maxValue: 10000,
        name: 'C16:0',
        tooltip: '',
      },
      c_16_1: {
        maxValue: 10000,
        name: 'C16:1',
        tooltip: '',
      },
      c_17_0: {
        maxValue: 10000,
        name: 'C17:0',
        tooltip: '',
      },
      c_17_1: {
        maxValue: 10000,
        name: 'C17:1',
        tooltip: '',
      },
      c_18_0: {
        maxValue: 10000,
        name: 'C18:0',
        tooltip: '',
      },
      c_18_1: {
        maxValue: 10000,
        name: 'C18:1',
        tooltip: '',
      },
      c_18_2: {
        maxValue: 10000,
        name: 'C18:2',
        tooltip: 'LA',
      },
      c_18_3: {
        maxValue: 10000,
        name: 'C18:3',
        tooltip: 'ALA/GLA',
      },
      c_18_4: {
        maxValue: 10000,
        name: 'C18:4',
        tooltip: '',
      },
      c_20_0: {
        maxValue: 10000,
        name: 'C20:0',
        tooltip: '',
      },
      c_20_1: {
        maxValue: 10000,
        name: 'C20:1',
        tooltip: '',
      },
      c_20_3: {
        maxValue: 10000,
        name: 'C20:3',
        tooltip: '',
      },
      c_20_4: {
        maxValue: 10000,
        name: 'C20:4',
        tooltip: 'ARA',
      },
      c_20_5: {
        maxValue: 10000,
        name: 'EPA',
        tooltip: 'C20:5',
      },
      c_22_1: {
        maxValue: 10000,
        name: 'C22:1',
        tooltip: '',
      },
      c_22_5: {
        maxValue: 10000,
        name: 'DPA',
        tooltip: '',
      },
      c_22_6: {
        maxValue: 10000,
        name: 'DHA',
        tooltip: 'C22:6',
      },
      cholesterol: {
        maxValue: 10000,
        name: 'Cholesterol',
        tooltip: '',
      },
      jnkt: {
        maxValue: 10000,
        name: 'Jednonienasycone ogółem',
        tooltip: '',
      },
      n_3: {
        maxValue: 10000,
        name: 'n-3',
        tooltip: 'Omega 3',
      },
      n_6: {
        maxValue: 10000,
        name: 'n-6',
        tooltip: 'Omega 6',
      },
      nkt: {
        maxValue: 10000,
        name: 'Nasycone ogółem',
        tooltip: '',
      },
      wnkt: {
        maxValue: 10000,
        name: 'Wielonienasycone ogółem',
        tooltip: '',
      },
    },
  },
  {
    name: 'Inne',
    nutrients: {
      ash: {
        maxValue: 10000,
        name: 'Popiół',
        tooltip: '',
      },
      carbohydrate_exchanger: {
        maxValue: 10000,
        name: 'Wymienniki węglowodanowe',
        tooltip: '',
      },
      carbohydrates_energy: {
        maxValue: 10000,
        name: '% energii z węglowodanów ogółem',
        tooltip: 'Węglowodany przyswajalne + błonnik',
      },
      fat_energy: {
        maxValue: 10000,
        name: '% energii z tłuszczów',
        tooltip: '',
      },
      fructose: {
        maxValue: 10000,
        name: 'Fruktoza',
        tooltip: '',
      },
      glucose: {
        maxValue: 10000,
        name: 'Glukoza',
        tooltip: '',
      },
      glycemic_index: {
        maxValue: 100,
        name: 'Indeks glikemiczny',
        tooltip: '',
      },
      glycemic_load: {
        maxValue: 100,
        name: 'Ładunek glikemiczny',
        tooltip: '',
      },
      lactose: {
        maxValue: 10000,
        name: 'Laktoza',
        tooltip: '',
      },
      // protein_energy: {
      //   name: '% energii z białek',
      //   tooltip: '',
      //   maxValue: 10000
      // },
      protein_fat_exchangers: {
        maxValue: 10000,
        name: 'Wymienniki białkowo-tłuszczowe',
        tooltip: '',
      },
      salt: {
        maxValue: 10000,
        name: 'Sól',
        tooltip: '',
      },
      simple_sugars_sum: {
        maxValue: 40000,
        name: 'Suma cukrów prostych',
        tooltip:
          'Cukry proste są sumą dostępnych danych o składnikach: glukozy, fruktozy, laktozy i sacharozy',
      },
      starch: {
        maxValue: 10000,
        name: 'Skrobia',
        tooltip: '',
      },
      sucrose: {
        maxValue: 10000,
        name: 'Sacharoza',
        tooltip: '',
      },
      waste: {
        maxValue: 10000,
        name: 'Odpadki',
        tooltip: '',
      },
      water: {
        maxValue: 10000,
        name: 'Woda',
        tooltip: '',
      },
    },
  },
]

export const normsRanges = {
  age_or_pregnancy_or_lactation_range: [
    '0-0,5',
    '0,5-1',
    '1-2',
    '2-3',
    '4-6',
    '7-9',
    '10-12',
    '13-15',
    '16-18',
    '19-30',
    '31-50',
    '51-65',
    '66-75',
    '>75',
    '<19 pregnancy',
    '>19 pregnancy',
    '<19 lactation',
    '>19 lactation',
  ] as const,
  female: {
    c_20_4: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ] as const,
    c_20_5: [
      null,
      null,
      null,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
    ] as const,
    c_22_6: [
      null,
      0.1,
      0.1,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.2,
      0.2,
      0.2,
      0.2,
    ] as const,
    calcium: [
      null,
      260,
      700,
      700,
      1000,
      1000,
      1300,
      1300,
      1300,
      1000,
      1000,
      1200,
      1200,
      1200,
      1300,
      1000,
      1300,
      1000,
    ] as const,
    carbohydrate_exchanger: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ] as const,
    carbohydrates: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ] as const,
    cholesterol: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ] as const,
    copper: [
      null,
      0.3,
      0.3,
      0.3,
      0.4,
      0.7,
      0.7,
      0.9,
      0.9,
      0.9,
      0.9,
      0.9,
      0.9,
      0.9,
      1,
      1,
      1.3,
      1.3,
    ] as const,
    fat: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ] as const,
    fiber: [
      null,
      null,
      10,
      10,
      14,
      16,
      19,
      19,
      21,
      25,
      25,
      25,
      20,
      20,
      null,
      null,
      null,
      null,
    ] as const,
    folate_total: [
      null,
      80,
      150,
      150,
      200,
      300,
      300,
      400,
      400,
      400,
      400,
      400,
      400,
      400,
      600,
      600,
      500,
      500,
    ] as const,
    glycemic_index: [
      55, 55, 55, 55, 55, 55, 55, 55, 55, 55, 55, 55, 55, 55, 55, 55, 55, 55,
    ] as const,
    glycemic_load: [
      80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80,
    ] as const,
    iodine: [
      null,
      70,
      90,
      90,
      90,
      100,
      120,
      150,
      150,
      150,
      150,
      150,
      150,
      150,
      220,
      220,
      290,
      290,
    ] as const,
    iron: [null, 11, 7, 7, 10, 10, 10, 15, 15, 18, 18, 10, 10, 10, 27, 27, 10, 10] as const,
    magnesium: [
      null,
      70,
      80,
      80,
      130,
      130,
      240,
      360,
      360,
      310,
      320,
      320,
      320,
      320,
      400,
      360,
      360,
      320,
    ] as const,
    manganese: [
      null,
      0.6,
      1.2,
      1.2,
      1.5,
      1.5,
      1.6,
      1.6,
      1.6,
      1.8,
      1.8,
      1.8,
      1.8,
      1.8,
      2,
      2,
      2.6,
      2.6,
    ] as const,
    niacin: [null, 5, 6, 6, 8, 12, 12, 14, 14, 14, 14, 14, 14, 14, 18, 18, 17, 17] as const,
    phosphorus: [
      null,
      300,
      460,
      460,
      500,
      600,
      1250,
      1250,
      1250,
      700,
      700,
      700,
      700,
      700,
      1250,
      700,
      1250,
      700,
    ] as const,
    potassium: [
      null,
      750,
      800,
      800,
      1100,
      1800,
      2400,
      3000,
      3500,
      3500,
      3500,
      3500,
      3500,
      3500,
      3500,
      3500,
      4000,
      4000,
    ] as const,
    protein: [
      null,
      null,
      1.17,
      1.17,
      1.1,
      1.1,
      1.1,
      1.1,
      0.95,
      0.9,
      null,
      null,
      null,
      null,
      null,
      1.2,
      1.45,
      null,
    ] as const,
    protein_fat_exchangers: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ] as const,
    riboflavin: [
      null,
      0.4,
      0.5,
      0.5,
      0.6,
      0.9,
      1,
      1.1,
      1.1,
      1.1,
      1.1,
      1.1,
      1.1,
      1.1,
      1.4,
      1.4,
      1.6,
      1.6,
    ] as const,
    simple_sugars_sum: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ] as const,
    sodium: [
      null,
      370,
      750,
      750,
      1000,
      1200,
      1300,
      1500,
      1500,
      1500,
      1500,
      1500,
      1500,
      1500,
      1500,
      1500,
      1500,
      1500,
    ] as const,
    thiamin: [
      null,
      0.3,
      0.5,
      0.5,
      0.6,
      0.9,
      1,
      1.1,
      1.1,
      1.1,
      1.1,
      1.1,
      1.1,
      1.1,
      1.4,
      1.4,
      1.5,
      1.5,
    ] as const,
    vitamin_A_RAE: [
      null,
      350,
      400,
      400,
      450,
      500,
      600,
      700,
      700,
      700,
      700,
      700,
      700,
      700,
      750,
      770,
      1200,
      1300,
    ] as const,
    vitamin_B_12: [
      null,
      0.5,
      0.8,
      0.8,
      1.2,
      1.8,
      1.8,
      2.4,
      2.4,
      2.4,
      2.4,
      2.4,
      2.4,
      2.4,
      2.6,
      2.6,
      2.8,
      2.8,
    ] as const,
    vitamin_B6: [
      null,
      0.4,
      0.5,
      0.5,
      0.6,
      1,
      1.2,
      1.2,
      1.2,
      1.3,
      1.3,
      1.5,
      1.5,
      1.5,
      1.9,
      1.9,
      2,
      2,
    ] as const,
    vitamin_C: [
      null,
      20,
      40,
      40,
      50,
      50,
      50,
      65,
      65,
      75,
      75,
      75,
      75,
      75,
      80,
      85,
      115,
      120,
    ] as const,
    vitamin_D: [null, 10, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15] as const,
    vitamin_E: [null, 5, 6, 6, 6, 7, 8, 8, 8, 8, 8, 8, 8, 8, 10, 10, 11, 11] as const,
    zinc: [null, 3, 3, 3, 5, 5, 8, 9, 9, 8, 8, 8, 8, 8, 12, 11, 13, 12] as const,
  },
  male: {
    c_20_4: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ] as const,
    c_20_5: [
      null,
      null,
      null,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      null,
      null,
      null,
      null,
    ] as const,
    c_22_6: [
      null,
      0.1,
      0.1,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      0.125,
      null,
      null,
      null,
      null,
    ] as const,
    calcium: [
      null,
      260,
      700,
      700,
      1000,
      1000,
      1300,
      1300,
      1300,
      1000,
      1000,
      1000,
      1200,
      1200,
      null,
      null,
      null,
      null,
    ] as const,
    carbohydrates: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ] as const,
    cholesterol: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ] as const,
    copper: [
      null,
      0.3,
      0.3,
      0.3,
      0.4,
      0.7,
      0.7,
      0.9,
      0.9,
      0.9,
      0.9,
      0.9,
      0.9,
      0.9,
      null,
      null,
      null,
      null,
    ] as const,
    fat: [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
    ] as const,
    fiber: [
      null,
      null,
      10,
      10,
      14,
      16,
      19,
      19,
      21,
      25,
      25,
      25,
      20,
      20,
      null,
      null,
      null,
      null,
    ] as const,
    folate_total: [
      null,
      80,
      150,
      150,
      200,
      300,
      300,
      400,
      400,
      400,
      400,
      400,
      400,
      400,
      null,
      null,
      null,
      null,
    ] as const,
    glycemic_index: [
      55,
      55,
      55,
      55,
      55,
      55,
      55,
      55,
      55,
      55,
      55,
      55,
      55,
      55,
      null,
      null,
      null,
      null,
    ] as const,
    glycemic_load: [80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, null, null, null, null],
    iodine: [
      null,
      70,
      90,
      90,
      90,
      100,
      120,
      150,
      150,
      150,
      150,
      150,
      150,
      150,
      null,
      null,
      null,
      null,
    ] as const,
    iron: [null, 11, 7, 7, 10, 10, 10, 12, 12, 10, 10, 10, 10, 10, null, null, null, null] as const,
    magnesium: [
      null,
      70,
      80,
      80,
      130,
      130,
      240,
      410,
      410,
      400,
      420,
      420,
      420,
      420,
      null,
      null,
      null,
      null,
    ] as const,
    manganese: [
      null,
      0.6,
      1.2,
      1.2,
      1.5,
      1.5,
      1.9,
      2.2,
      2.2,
      2.3,
      2.3,
      2.3,
      2.3,
      2.3,
      null,
      null,
      null,
      null,
    ] as const,
    niacin: [null, 5, 6, 6, 8, 12, 12, 16, 16, 16, 16, 16, 16, 16, null, null, null, null] as const,
    phosphorus: [
      null,
      300,
      460,
      460,
      500,
      600,
      1250,
      1250,
      1250,
      700,
      700,
      700,
      700,
      700,
      null,
      null,
      null,
      null,
    ] as const,
    potassium: [
      null,
      750,
      800,
      800,
      1100,
      1800,
      2400,
      3000,
      3500,
      3500,
      3500,
      3500,
      3500,
      3500,
      null,
      null,
      null,
      null,
    ] as const,
    protein: [
      null,
      null,
      1.17,
      1.17,
      1.1,
      1.1,
      1.1,
      1.1,
      0.95,
      0.9,
      0.9,
      0.9,
      0.9,
      0.9,
      null,
      null,
      null,
      null,
    ] as const,
    riboflavin: [
      null,
      0.4,
      0.5,
      0.5,
      0.6,
      0.9,
      1,
      1.3,
      1.3,
      1.3,
      1.3,
      1.3,
      1.3,
      1.3,
      null,
      null,
      null,
      null,
    ] as const,
    sodium: [
      null,
      370,
      750,
      750,
      1000,
      1200,
      1300,
      1500,
      1500,
      1500,
      1500,
      1500,
      1500,
      1500,
      null,
      null,
      null,
      null,
    ] as const,
    thiamin: [
      null,
      0.3,
      0.5,
      0.5,
      0.6,
      0.9,
      1,
      1.2,
      1.2,
      1.3,
      1.3,
      1.3,
      1.3,
      1.3,
      null,
      null,
      null,
      null,
    ] as const,
    vitamin_A_RAE: [
      null,
      350,
      400,
      400,
      450,
      500,
      600,
      900,
      900,
      900,
      900,
      900,
      900,
      900,
      null,
      null,
      null,
      null,
    ] as const,
    vitamin_B_12: [
      null,
      0.5,
      0.8,
      0.8,
      1.2,
      1.8,
      1.8,
      2.4,
      2.4,
      2.4,
      2.4,
      2.4,
      2.4,
      2.4,
      null,
      null,
      null,
      null,
    ] as const,
    vitamin_B6: [
      null,
      0.4,
      0.5,
      0.5,
      0.6,
      1,
      1.2,
      1.3,
      1.3,
      1.3,
      1.3,
      1.7,
      1.7,
      1.7,
      null,
      null,
      null,
      null,
    ] as const,
    vitamin_C: [
      null,
      20,
      40,
      40,
      50,
      50,
      50,
      75,
      75,
      90,
      90,
      90,
      90,
      90,
      null,
      null,
      null,
      null,
    ] as const,
    vitamin_D: [
      null,
      10,
      15,
      15,
      15,
      15,
      15,
      15,
      15,
      15,
      15,
      15,
      15,
      15,
      null,
      null,
      null,
      null,
    ] as const,
    vitamin_E: [
      null,
      5,
      6,
      6,
      6,
      7,
      10,
      10,
      10,
      10,
      10,
      10,
      10,
      10,
      null,
      null,
      null,
      null,
    ] as const,
    zinc: [null, 3, 3, 3, 5, 5, 8, 11, 11, 11, 11, 11, 11, 11, null, null, null, null] as const,
  },
}
